module.exports = __webpack_public_path__ + "page13seven-d326060af4d11b13c3b9e48b42a00c2b.png";